import { user, reservation, doctor, push, surgery, scar, main, version } from '../api'
import router from '../router/index'
import {
  setCookie,
  getCookie,
  removeCookie
} from '../utils/cookieNew'

const newVar = {
  VERSION_CHECK ({ commit }, payload) {
    return version.versionCheck(payload)
      .then((data) => commit('SET_VERSION_CHECK', data.response))
  },
  IDENTITY ({ commit }) {
    return user.identity()
      .then((data) => commit('SET_IDENTITY', data.response.encData))
  },
  ID_FIND ({ commit }, userData) {
    return user.idFind(userData)
      .then((data) => {
        commit('SET_ID', data.response.id)
        sessionStorage.setItem('findId', data.response.id)
      })
  },
  ID_CHECK ({ commit }, userData) {
    return user.checkId(userData)
  },
  LOGIN_USER ({ commit, getters }, userData) {
    return user.loginUser(userData)
      .then(function (data) {
        setCookie('userName', data.response.userName, { secure: true, expires: 30 })
        commit('SET_USERNAME', data.response.userName)
        setCookie('token', data.response.token, { secure: true, expires: 30 })
        commit('SET_TOKEN', data.response.token)
        setCookie('userId', data.response.id, { secure: true, expires: 30 })
        commit('SET_ID', data.response.id)
        setCookie('loginLogicPassed', true, { secure: true, expires: 30 })
        console.log('하이퍼 -로그인-', sessionStorage.getItem('pathToLoadAuthPre'))
        console.log('권필경로 -로그인-', sessionStorage.getItem('pathToLoadAuth'))
        console.log('권없경로 -로그인-', sessionStorage.getItem('pathToLoadUnAuth'))
        router.push(sessionStorage.getItem('pathToLoadAuthPre') || sessionStorage.getItem('pathToLoadAuth') || '/')
      })
  },
  FETCH_MEDICAL_DATE ({ commit }, userData) {
    return reservation.getMedicalDate(userData)
      .then((data) => {
        commit('SET_MEDICAL_MONTH_DATE', data.response.medicalMonthDate)
      })
  },
  LOGOUT_USER ({ commit }) {
    return user.logoutUser()
      .then(() => {
        removeCookie('userName')
        commit('SET_USERNAME', '')
        removeCookie('token')
        commit('SET_TOKEN', '')
        removeCookie('userId')
        commit('SET_ID', '')
        if (getCookie('deviceId') !== undefined) {
          const url = 'thanq://logout'
          document.location.href = url
        }
      })
  },
  AUTO_LOGIN ({ commit, getters }, userData) {
    return user.autoLogin(userData)
      .then(function (data) {
        console.log('api레벨에서의 오토로그인')
        setCookie('userName', data.response.userName, { secure: true, expires: 30 })
        commit('SET_USERNAME', data.response.userName)
        setCookie('token', data.response.token, { secure: true, expires: 30 })
        console.log('재발행한 토큰', getCookie('token'))
        commit('SET_TOKEN', data.response.token)
        // sessionStorage.setItem('autoLoginToken', data.response.token)
        // console.log('이거있니?', sessionStorage.getItem('autoLoginToken'))
        setCookie('userId', data.response.id, { secure: true, expires: 30 })
        // commit('SET_PASSED_LOGIC', true)
        commit('SET_ID', data.response.id)
        const url = 'thanq://login?sessionToken=' + getCookie('token') + '&autoLogin=true'
        document.location.href = url
        // sessionStorage.setItem('loginLogicPassed', 'true')
        const urlString = document.location.href
        if (urlString.indexOf('login') !== -1) {
          router.push(sessionStorage.getItem('pathToLoadAuthPre') || sessionStorage.getItem('pathToLoadAuth') || '/')
        }
      })
  },
  FETCH_USER_DATA ({ commit, getters }) {
    return user.userInfo()
      .then(function (data) {
        commit('SET_USER_INFO', data.response.info)
      })
  },
  MODIFY_USER_DATA ({ commit }, userData) {
    return user.userInfoChange(userData)
  },
  PW_FIND_APPROVAL ({ commit }, userData) {
    return user.pwFindApproval(userData)
      .then((data) => {
        commit('SET_ID', data.response.id)
      })
  },
  PW_FIND_CERTIFY ({ commit }, userData) {
    return user.pwFindCertify(userData)
      .then((data) => {
        commit('SET_USERNAME', data.response.userName)
        commit('SET_ID', data.response.id)
      })
  },
  CHECK_PW ({ commit, getters }, userData) {
    return user.checkPw(userData)
      .then(() => {
        commit('SET_CHECKED_PW', true)
      })
  },
  CHECK_PW_INFO ({ commit, getters }, userData) {
    return user.checkPw(userData)
      .then(() => {
        commit('SET_CHECKED_PW', true)
      })
  },
  CHECK_PW_SECESSION ({ commit, getters }, userData) {
    return user.checkPw(userData)
  },
  SECESSION ({ commit }) {
    return user.secession()
      .then(() => {
        removeCookie('userName')
        commit('SET_USERNAME', '')
        removeCookie('token')
        commit('SET_TOKEN', '')
        removeCookie('userId')
        commit('SET_ID', '')
        if (getCookie('deviceId') !== undefined) {
          const url = 'thanq://logout'
          document.location.href = url
        }
        router.push('/modifyUser/secession')
      })
  },
  CHANGE_PW ({ commit }, userData) {
    return user.changePw(userData)
      .then(() => {
        // removeCookie('userName')
        // commit('SET_USERNAME', '')
        // removeCookie('token')
        // commit('SET_TOKEN', '')
        // removeCookie('userId')
        // commit('SET_ID', '')
        // if (getCookie('deviceId') !== undefined) {
        //   const url = 'thanq://logout'
        //   document.location.href = url
        // }
      })
  },
  CHECK_RESERVATION ({ commit }) {
    return reservation.check()
      .then((data) => commit('SET_RESERVATION_CHECK', data.response.reservationInfo))
  },
  CHECK_RESERVATION_MAIN ({ commit }) {
    return reservation.check()
      .then((data) => commit('SET_RESERVATION_CHECK', data.response.reservationInfo))
  },
  COMING_LIST ({ commit }, category) {
    return reservation.coming(category)
      .then((data) => commit('SET_COMING_LIST', data.response))
  },
  VISIT_LIST ({ commit }) {
    return reservation.visit()
      .then((data) => commit('SET_VISIT_LIST', data.response))
  },
  FETCH_DOCTOR_LIST ({ commit }, reasonData) {
    return reservation.selectDoctor(reasonData)
      .then((data) => commit('SET_DOCTOR', data.response.doctorInfo))
  },
  TEL_RESERVATION ({ commit }, telData) {
    return reservation.telReservation(telData)
  },
  TRANS_TEMPORARY_USER_DATA  ({ commit }, userData) {
    return user.joinUser(userData)
      .then((data) => {
      })
  },
  TRANS_USER_DATA  ({ commit }, userData) {
    return user.joinUser(userData)
      .then((data) => {
      })
  },
  DOCTOR_LIST ({ commit }) {
    return doctor.doctorList()
      .then((data) => commit('SET_DOCTOR', data.response))
  },
  DOCTOR_SCHEDULE ({ commit }) {
    return doctor.doctorSchedule()
      .then((data) => commit('SET_SCHEDULE', data.response))
  },
  FETCH_CALENDAR_LIST ({ commit, getters }, requestData) {
    return reservation.fetchCalendar(requestData)
      .then(function (data) {
        commit('SET_CALENDAR_LIST', data.response)
      })
  },
  UPDATE_RESERVATION_LIST ({ commit, getters }, requestData) {
    return reservation.updateReservation(requestData)
      .then(function (data) {
        commit('SET_RESERVATION_RESULT', data.result)
      })
  },
  FETCH_RESERVATION_LIST ({ commit, getters }, requestData) {
    return reservation.reservationList(requestData)
      .then(function (data) {
        commit('SET_RESERVATION_LIST', data.response.reservationList)
      })
  },
  RESERVATION_BOOKING ({ commit, getters }, payload) {
    return reservation.booking(payload)
      .then(function (data) {
        commit('SET_RESERVATION_RESULT', data.result)

      })
  },
  RESERVATION_REBOOKING ({ commit, getters }, payload) {
    return reservation.reBooking(payload)
      .then(function (data) {
        commit('SET_RESERVATION_RESULT', data.result);
      })
  },
  DELETE_RESERVATION ({ commit }, requestData) {
    return reservation.deleteReservation(requestData)
  },
  PATCH_PUSH_READ ({ commit }, requestData) {
    return push.read(requestData)
      .then(function (data) {
        // commit('SET_PUSH_RESULT', data.response.result)
      })
  },
  PUSH_LIST ({ commit }) {
    return push.pushList()
      .then((data) => commit('SET_PUSH_LIST', data.response.pushList))
  },
  TRANS_IS_RECEIVEPUSH ({ commit }, payload) {
    return push.pushReceived(payload)
      .then((data) => {
      })
  },
  PUSH_CHECK ({ commit }) {
    return push.pushCheck()
      .then((data) => commit('SET_PUSH_CHECK', data.response.push))
  },
  SURGERY_LIST ({ commit }, payload) {
    return surgery.surgeryList(payload)
      .then((data) => commit('SET_SURGERY_LIST', data.response.surgeryList))
  },
  SURGERY_APPLY ({ commit }, payload) {
    return surgery.surgeryApply(payload)
  },
  KAKAO_URL ({ commit }) {
    return surgery.kakaoUrl()
      .then((data) => commit('SET_KAKAO_URL', data.response.url))
  },
  FETCH_SCARINFO  ({ commit }) {
    return scar.scarInfoList()
      .then((data) => commit('SET_SCARINFO_LIST', data.response.scarInfoList))
  },
  APPLY_SCAR  ({ commit }, payload) {
    return scar.scarApply(payload)
      .then((data) => commit('SET_SCAR_INFOCODE', data.response.scarInfoCode))
  },
  FETCH_SCAR_UPLOAD  ({ commit }, payload) {
    return scar.scarUploadList(payload)
      .then((data) => {
        commit('SET_UPLOAD_LIST', data.response.scarList)
      })
  },
  UPLOARD_SCAR_IMAGE ({ commit }, payload) {
    return scar.scarUpload(payload)
  },
  FETCH_SCAR_IMAGE  ({ commit }, payload) {
    return scar.scarImageFetch(payload)
      .then((data) => commit('SET_FETCHED_SCARIMG', data))
  },
  DELETE_SCAR_IMAGE  ({ commit }, payload) {
    return scar.scarImageDelete(payload)
  },
  BANNER ({ commit }) {
    return main.banner()
      .then((data) => commit('SET_BANNER', data.response))
  },
  BANNER_DETAIL ({ commit }) {
    return main.bannerDetail()
      .then((data) => commit('SET_BANNER_DETAIL', data.response))
  }
}
const actions = newVar

export default actions
